import {trigger, filter} from './lang.js';

const mod = (_a,_b) => ((_a%_b)+_b)%_b;

// simply disallows obviously dissonant notes from playing

export const noDissonance = () => {
    // list of notes so far on this step
    let notes = [];
    let lastStepNumber = undefined;
    return (...args) => {
        let [stepData, stepNumber, time, effect] = args;

        if (!stepData) {
            return filter(true);
        }

        if (lastStepNumber !== stepNumber) {
            notes = [];
        }

        lastStepNumber = stepNumber;

        let {transpose} = stepData;
        let newTranspose = transpose;
        if (notes.includes(mod(transpose - 1))) {
            newTranspose = transpose - 1;
        }

        if (notes.includes(mod(transpose + 1, 12))) {
            newTranspose = transpose + 1;
        }

        notes.push(mod(newTranspose, 12));
        if (transpose === newTranspose) {
            return filter(true);
        }

        // otherwise create a new trigger w this
        // "better" transpose
        let _stepData = effect.getStep(stepData);
        _stepData.transpose = newTranspose;
        return trigger({
            stepData: _stepData,
            time,
            stepNumber
        });
    };
};
